export default "__VITE_ASSET__BgZtRVqI__"